import React from 'react';
import { Trans } from 'react-i18next';
import Button from '../../../../Button/button';
import { ButtonTypes } from '../../../../../Interfaces/componentTypes';
import { useGeneralHooks } from '../../../../../Hooks/hooks';
import useDeleteCompanyDialog from './deleteCompanyDialog-hooks';
import { Trash } from '../../../../../Assets/Icons';
import styles from './deleteCompany.module.scss';

interface IProps {
    onClose: () => void,
    businessName: string,
    businessId: number,
    cb?:()=>void
};

const DeleteCompanyDialog: React.FC<IProps> = (props) => {
    const { businessName, businessId, onClose, cb = ()=>{} } = props;
    const { onRemoveCompany, isLoading } = useDeleteCompanyDialog(onClose!,cb);
    const { t } = useGeneralHooks();

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div>
                    <img src={Trash} alt='TrashIcon' />
                    <p>{t('Business.Remove')}</p>
                </div>
            </div>
            <div className={styles.body}>
                <div className={styles.text}>
                <Trans
                    i18nKey="Business.Remove_Text"
                    values={{ businessName }}
                    components={{
                        strong: <span className={styles.businessTitle} />,
                    }}
                />
                </div>
                <div className={styles.buttonsRow}>
                    <Button
                        type='button'
                        buttonType={ButtonTypes.Secondary}
                        title={t('Buttons.Cancel')}
                        onClick={(e) => {
                            e.stopPropagation()
                            onClose()
                        }}
                        buttonStyle={styles.button}
                        buttonTitleStyle={styles.buttonTitle}
                    />
                    <Button
                        type='button'
                        buttonType={ButtonTypes.Primery}
                        title={t('Buttons.Confirm')}
                        onClick={(e) => {
                            e.stopPropagation();
                            onRemoveCompany(businessId)
                        }}
                        isLoading={isLoading}
                        buttonStyle={styles.button}
                        buttonTitleStyle={styles.buttonTitle}
                    />
                </div>
            </div>
        </div>
    )
}

export default DeleteCompanyDialog
